export const getCsrfToken = () => {
  const token = document.querySelector('[name="csrf-token"]')?.content ||
                document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
  
  if (!token) {
    console.warn('CSRF token not found')
    return ''
  }
  
  return token
}